/* Keeps the Add to cart total in step with the bundle cards.
   The page renders its own prices from its own table, so after any re-render
   the button could fall back to the old figure. This watches the total and
   rewrites it, permanently — not on a timer that expires. */
(function(){
var MAP=window.IF_PRICE_MAP||{};
var B=window.IF_BUNDLES||[];

function fixTotal(){
var t=document.getElementById('if-total');
if(!t)return;
var v=(t.textContent||'').trim().replace('$','');
if(MAP[v]&&t.textContent.indexOf(MAP[v])<0){t.textContent=MAP[v];return;}
/* fall back to the selected bundle if the figure is unknown */
var units=document.getElementById('if-units');
if(units&&B.length){
var n=units.children.length;
var want=B[Math.min(Math.max(n,1),B.length)-1].price;
if(v!==want&&MAP[v])t.textContent=want;
}
}

function fixSticky(){
var bar=document.getElementById('if-sticky');
if(!bar)return;
var spans=bar.querySelectorAll('span,strong,b');
for(var i=0;i<spans.length;i++){
var s=spans[i];
if(s.children.length)continue;
var m=(s.textContent||'').match(/\$(\d+\.\d{2})/);
if(m&&MAP[m[1]])s.textContent=s.textContent.replace('$'+m[1],'$'+MAP[m[1]]);
}
}

function run(){fixTotal();fixSticky();}

if(window.MutationObserver){
var attach=setInterval(function(){
var t=document.getElementById('if-total');
if(t&&!t.getAttribute('data-if-w')){
t.setAttribute('data-if-w','1');
new MutationObserver(run).observe(t,{childList:true,characterData:true,subtree:true});
}
},500);
setTimeout(function(){clearInterval(attach);},20000);
}
setInterval(run,700);
if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
})();
